import BucketApiRequest from "./BucketApiRequest";
import { GETTING_STARTED_GET_RESIDENT } from "../ApiUrls";

export default class GettingStartedGetResidentRequest extends BucketApiRequest {
  getUrl = () => {
    return GETTING_STARTED_GET_RESIDENT;
  };
}
